// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  accueil: {
    presentation: '/presentation-de-l-agence',
    mot_du_ministre: '/mot-du-ministre',
    mot_du_dga: '/mot-du-dga',
    charte_de_l_investisseur: '/charte-de-l-investiseur',
    dix_raison_d_investir_au_togo: '/10-raisons-d-investir-au-togo',
    documents: '/documents',
    actualites: '/actualites',
    communique: '/communique',
    foire_aux_question: '/foire-aux-question',
    home: '/',
  },
  pourquoi_le_togo: {
    le_togo_en_bref: '/pourquoi-le-togo/le-togo-en-bref',
    stat_chiffre_cle: '/pourquoi-le-togo/statistiques-chiffres-cle',
    vivre_au_togo: '/pourquoi-le-togo/vivre-au-togo',
    travailler_au_togo: '/pourquoi-le-togo/travailler-au-togo',
    site_touristiques: '/pourquoi-le-togo/sites-touristiques',
    galerie_photo: '/pourquoi-le-togo/galerie-photo',
  },

  investire_au_togo: {
    r10_d_investir_au_togo: '/investir-au-togo/10-raisons-d-investir-au-togo',
    le_guide_d_investisseur: '/investir-au-togo/le-guide-d-investisseur',
    profil_secteur: '/investir-au-togo/profil-secteur',
  },
  zone_franche: {
    zone_franche: '/zone-franche',
    cdts_d_iligibilites: '/zone-franche/conditions-deligibilite',
    secteurs_eligibles: '/zone-franche/secteurs-iligible',
    avantages_accordes: '/zone-franche/avantages-accordes',
    procedure_d_obtention_agrement: '/zone-franche/procedure-d-obtention-d-agrement',
    socitetes_en_activite: '/zone-franche/societes-en-activite',
    statistique: '/zone-franche/staistiques',
  },
  code_des_investisseurs: {
    code_des_investisseurs: '/code-des-investisseurs',
    cdts_d_iligibilites: '/code-des-investisseurs/conditions-d-iligibilite',
    secteurs_eligibles: '/code-des-investisseurs/secteurs-iligible',
    avantages_accordes: '/code-des-investisseurs/avantages-accordes',
    procedure_d_obtention_agrement: '/code-des-investisseurs/procedure-d-obtention-d-agrement',
    entreprises_en_activite: '/code-des-investisseurs/entreprises-en-activite',
    statistique: '/code-des-investisseurs/staistiques',
  },
  guichet_unique: {
    guichet_unique: '/guichet-unique',
    portail_de_l_investissement: '/guichet-unique/portail-de-l-investissement',
    guichet_unique_de_l_investissement: '/guichet-unique/guichet-unique-de-l-investissement',
    apercu_d_une_procedure_documentee: '/guichet-unique/aprecu-d-une-procedure-documentee',
  },
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  evenement: '/evenement',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
